// extracted by mini-css-extract-plugin
export var box = "DirectionsModal-module--box--a864e";
export var box_md = "DirectionsModal-module--box_md--96039";
export var box_xmd = "DirectionsModal-module--box_xmd--912ab";
export var box_flex = "DirectionsModal-module--box_flex--14d09";
export var box_lg = "DirectionsModal-module--box_lg--827f0";
export var box_sm = "DirectionsModal-module--box_sm--edac1";
export var box_outer = "DirectionsModal-module--box_outer--39e7f";
export var box_whiteBg = "DirectionsModal-module--box_white-bg--7b7de";
export var box_noMarginBottom = "DirectionsModal-module--box_no-margin-bottom--61142";
export var box_noPadding = "DirectionsModal-module--box_no-padding--e88f9";
export var box_outerGray = "DirectionsModal-module--box_outer-gray--8c31c";
export var box_dark = "DirectionsModal-module--box_dark--9107d";
export var box_zIndex = "DirectionsModal-module--box_z-index--fbd50";
export var box_zIndex6 = "DirectionsModal-module--box_z-index-6--4f232";
export var box_eventsWithLine = "DirectionsModal-module--box_events-with-line--5974b";
export var box_featuresAo = "DirectionsModal-module--box_features-ao--796c5";
export var box_verticalPaddings = "DirectionsModal-module--box_vertical-paddings--cee4d";
export var clearP = "DirectionsModal-module--clearP--46063";
export var clearP_vc = "DirectionsModal-module--clearP_vc--45701";
export var layout = "DirectionsModal-module--layout--fcec5";
export var title = "DirectionsModal-module--title--9856b";
export var fadeInAnimation = "DirectionsModal-module--fadeInAnimation--2b461";
export var placeHolderShimmer = "DirectionsModal-module--placeHolderShimmer--2e875";